"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var immer_1 = __importDefault(require("immer"));
var react_redux_1 = require("react-redux");
var TimeUtil_1 = require("../util/TimeUtil");
var useNow_1 = __importDefault(require("./useNow"));
function usePlayers(_a) {
    var _b = _a === void 0 ? { withTimeUpdate: false } : _a, withTimeUpdate = _b.withTimeUpdate;
    var now = (0, useNow_1.default)({ standby: !withTimeUpdate });
    var players = (0, react_redux_1.useSelector)(function (state) { return state.players; });
    if (withTimeUpdate && players.every(function (player) { return player.time; })) {
        return (0, immer_1.default)(players, function (draft) { return (0, TimeUtil_1.updatePlayersTime)(draft, now); });
    }
    else {
        return players;
    }
}
exports.default = usePlayers;
